import React, { useState, useEffect, useRef } from 'react';

const STATS = [
  { end: 13, suffix: '+', label: 'Projects Delivered', sub: 'Across MH & GJ' },
  { end: 100, suffix: 'k+', label: 'Sq. Ft. Built', sub: 'Industrial grade' },
  { end: 4, suffix: '+', label: 'Zones Covered', sub: 'MIDC | GIDC | Daund' },
];

const CountUp = ({ end, suffix, active }) => {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!active) return;
    let cur = 0;
    const inc = Math.max(1, Math.ceil(end / 50));
    const t = setInterval(() => {
      cur = Math.min(cur + inc, end);
      setVal(cur);
      if (cur >= end) clearInterval(t);
    }, 20);
    return () => clearInterval(t);
  }, [active, end]);
  return <>{val}{suffix}</>;
};

export const PortfolioHeroStats = () => {
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setActive(true); }, { threshold: 0.4 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={ref} className="border-b border-[#4A4A4A] bg-[#0D0D0D]" data-testid="portfolio-hero-stats">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
          <div>
            <p className="section-label mb-4">Our Work</p>
            <h2 className="font-heading text-5xl lg:text-6xl text-white">PORTFOLIO</h2>
            <p className="text-[#9CA3AF] text-sm font-body mt-3 max-w-md">
              Industrial construction and project management delivered across Maharashtra and Gujarat — with precision, on time.
            </p>
          </div>
          <div className="flex flex-wrap gap-10 lg:gap-16">
            {STATS.map(({ end, suffix, label, sub }) => (
              <div key={label} className="border-l-2 border-[#C41E3A] pl-5" data-testid={`stat-${label.toLowerCase().replace(/\s+/g, '-')}`}>
                <div className="font-heading text-4xl lg:text-5xl text-white tabular-nums">
                  <CountUp end={end} suffix={suffix} active={active} />
                </div>
                <div className="text-white text-xs uppercase tracking-widest font-body mt-1">{label}</div>
                <div className="text-[#6B7280] text-xs font-body mt-0.5">{sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
